import { useMemo } from 'react';
import { Color } from '../../constants/Color';
import { Orientation } from '../../constants/Orientation';
import { decodeShutterstockFolderId } from '../hoc/extended-sources/withShutterstock.utils';
import { decodeUnsplashFolderId } from '../hoc/extended-sources/withUnsplash.utils';
import { decodePublicMediaFolderId } from '../hoc/withPublicMedia/utils';
import { useSources } from './useSources';

export interface ISearchBIParams {
  filterOrientation: Orientation;
  filterCategory: string;
  filterColor?: Color;
  filterType?: string;
}

export const useSearchBIParams = ({ source, folderId }): ISearchBIParams => {
  const { isShutterstock, isMediaFromWix, isUnsplash } = useSources({ source });

  return useMemo(() => {
    if (isShutterstock) {
      const decodedInfo = decodeShutterstockFolderId(folderId);
      return {
        filterOrientation: decodedInfo.orientation,
        filterColor: decodedInfo.color,
        filterCategory: decodedInfo.category,
        filterType: decodedInfo.mediaType,
      };
    }
    if (isMediaFromWix) {
      const decodedInfo = decodePublicMediaFolderId(folderId);
      return {
        filterOrientation: decodedInfo.orientation,
        filterColor: decodedInfo.color,
        filterCategory: decodedInfo.subCategoryId,
        filterType: decodedInfo.categoryId,
      };
    }
    if (isUnsplash) {
      const decodedInfo = decodeUnsplashFolderId(folderId);
      return {
        filterOrientation: decodedInfo.orientation,
        filterCategory: decodedInfo.category,
      };
    }

    return null;
  }, [isShutterstock, isMediaFromWix, isUnsplash, folderId]);
};
